import { render, staticRenderFns } from "./OMobibInfo.vue?vue&type=template&id=263236f9&"
import script from "./OMobibInfo.vue?vue&type=script&lang=js&"
export * from "./OMobibInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports